<!-- eslint-disable -->
<template>
  <div class="crm-tasks">
    <header class="crm-tasks__header shadow-sm">
      <div class="d-flex align-items-center">
        <div class="crm-tasks__icon mr-2">
          <feather-icon icon="CheckSquareIcon" size="24" />
        </div>
        <div>
          <h1 class="crm-tasks__title">Tasks</h1>
          <p class="crm-tasks__subtitle">
            The same task management used across the admin panel — without leaving the CRM.
          </p>
        </div>
      </div>
    </header>

    <!--
      The real Task Management screen, embedded.
      Same component, same original task backend — we only host it inside the CRM
      shell so the salesperson never leaves the CRM.
    -->
    <div class="crm-tasks__body">
      <task-managments />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import TaskManagments from '@/views/task-management-new/TaskManagments.vue'

export default {
  name: 'TasksCRM',
  components: { TaskManagments },
}
</script>

<style lang="scss" scoped>
.crm-tasks__header {
  background: linear-gradient(135deg, #7367f0, #9e95f5);
  color: #fff;
  border-radius: 0.6rem;
  padding: 1.1rem 1.3rem;
  margin-bottom: 1rem;
}

.crm-tasks__icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: 0.5rem;
  display: flex;
}

.crm-tasks__title {
  font-size: 1.35rem;
  font-weight: 700;
  margin: 0;
  color: #fff;
}

.crm-tasks__subtitle {
  margin: 0;
  opacity: 0.9;
  font-size: 0.85rem;
}
</style>
